module.exports = __webpack_public_path__ + "media/images/home/store_longer_badge-d8a0129b76309a961449853d11551028.svg";